import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CustomValidators } from "../../../shared/helpers/utilities/CustomValidators";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";

@Component({
  selector: "popup-report-historial",
  templateUrl: "./popup-report-historial.component.html",
  styleUrls: ["./popup-report-historial.component.css"],
})
export class PopupReportHistorialComponent implements OnInit {
  formGroup: FormGroup;
  group: any = {};
  public StartDate: Date;
  public EndDate: Date;
  public nowDate: Date;
  public maxDate: Date;
  public maxStartDate: Date = new Date();
  public maxEndDate: Date = new Date();
  public minStartDate: Date = new Date();
  public minEndDate: Date = new Date();

  constructor(
    public dialogRef: MatDialogRef<PopupReportHistorialComponent>,
    private formBuilder: FormBuilder,
    
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.nowDate = new Date();
    this.StartDate = new Date();
    this.StartDate.setHours(this.StartDate.getHours() - 6);
    this.minStartDate.setDate(this.minStartDate.getDate() - 90);

    this.EndDate = this.nowDate;
    this.EndDate.setHours(23,59,59);
    this.maxDate = new Date();
    
    this.maxDate.setMonth(this.maxDate.getMonth()+1);
    console.log(this.maxDate.toISOString().split('T')[0]);
    this.nowDate.setHours(this.nowDate.getHours() - 6);
    this.maxDate.setHours(this.maxDate.getHours() - 6);
    
      this.formGroup = this.formBuilder.group({
      initialDate: [null, Validators.required],
      finalDate: [null, Validators.required],
    },{validator: CustomValidators.DateLessThan('initialDate','finalDate')});
  }

  ngOnInit(): void {
    this.formGroup.controls["initialDate"].setValue(this.StartDate);
    this.formGroup.controls["finalDate"].setValue(this.EndDate);
  }

  
  limteFecha(event: MatDatepickerInputEvent<Date>) {
    if (event.value == null) {
      this.maxStartDate = null;
    }
    else{
      //como son 15, no tiene mucho caso bloquear dias de adelante
      // this.maxEndDate = this.nowDate;
      // this.minEndDate = new Date(event.value);

      //si se llega a requerir que haya más de 15 días, usar este
      const start = new Date(event.value).getTime();
      const addedDays = 15 * 24 * 60 * 60 * 1000;
      const end = new Date(start + addedDays);
      this.maxEndDate = end;
      this.minEndDate = new Date(event.value);

      if(this.EndDate > this.maxEndDate){
        this.EndDate = this.maxEndDate;
        this.formGroup.controls["finalDate"].setValue(this.EndDate);
      }else{
        this.EndDate = this.formGroup.controls["finalDate"].value;
      }
    }
  }

  cancel() {
    this.dialogRef.close({ search: false });
  }

  accept() {
    if (this.formGroup.value.initialDate != null && this.formGroup.value.finalDate != null) {
      this.formGroup.value.initialDate = this.formGroup.value.initialDate.toISOString();
      this.formGroup.value.finalDate = this.formGroup.value.finalDate.toISOString(); 
    }
    const { value, valid } = this.formGroup;
    if (valid) {
      this.dialogRef.close({
        search: true,
        formGroup: this.formGroup.value,
      });
    }
  }
}